import semver from 'semver';
import { UserInterfaceService } from '../../../services/user-interface-service';
import { UserPermissionService } from '../../../services/user-permission-service';

const v2IframeUrls = ['/v2carrierpickup', '/v2Subscriptions', '/v2API', '/v2Carriers'];
const v3Version = '3.0.0';

export const isV2iframePath = (pathname) => v2IframeUrls.some((url) => pathname.startsWith(url));

const canAccessLowerVersion = (settings) => {
  const lowestAllowedVersion = settings['ShipStationUI.MinimumSemVersion'];
  return semver.valid(lowestAllowedVersion) ? semver.lt(lowestAllowedVersion, v3Version) : true;
};

export const v2Check = (data) => {
  return new Promise((resolve, reject) => {
    const { settings, userSettings, currentUser, shouldResolve } = data.input;
    try {
      const isV3Native = UserInterfaceService.isV3Native(settings);
      const isUserPreferredUiVersion2 = UserInterfaceService.isUserPreferredUiVersion2(userSettings);
      const isRunningLocal = UserInterfaceService.isRunningLocally();
      const isSysAdmin = UserPermissionService.userIsSystemAdministrator(currentUser.roles);
      const pathname = window.location.pathname;
      if (
        canAccessLowerVersion(settings) &&
        !isSysAdmin &&
        !isV3Native &&
        isUserPreferredUiVersion2 &&
        !isRunningLocal &&
        !isV2iframePath(pathname)
      ) {
        UserInterfaceService.sendUserToV2();
        if (shouldResolve) {
          resolve();
        }
        // we return without resolving to make sure the state machine does NOT go to the next step
        return;
      }
      resolve();
    } catch (e) {
      reject(e);
    }
  });
};
